import React from 'react';
import { useAppointmentEndNotification } from '@hooks/useAppointmentEndNotification';
import { useRuntimeConfig } from 'vl-core/useRuntimeConfig';
import { Appointment } from 'vl-common/src/schemas/shared';
import useCallStatus from '@hooks/useCallStatus';

type EndNotification = Readonly<{
  appointment: Appointment;
  audioCallStatus?: string | null;
}>;

type Notification = EndNotification & {
  warningMinutes: number;
};

const CallEndNotification = ({ appointment, audioCallStatus, warningMinutes }: Notification) => {
  const videoCallStatus = useCallStatus(appointment);
  const isVideoCall = appointment?.call_type_code === 'VIDEO';
  const inProgress = isVideoCall ? videoCallStatus === 'in-progress' : audioCallStatus === 'in-progress';
  useAppointmentEndNotification(appointment, inProgress, warningMinutes);
  return null;
};

const AppointmentEndNotification = ({ appointment, audioCallStatus }: EndNotification) => {
  const { APPT_END_WARNING_MINS = 5 } = useRuntimeConfig();
  const { audit_appt_id, appt_type_code } = appointment;

  if (audit_appt_id || appt_type_code === 'CASEREV') return null;

  return (
    <CallEndNotification
      appointment={appointment}
      audioCallStatus={audioCallStatus}
      warningMinutes={APPT_END_WARNING_MINS}
    />
  );
};

export default AppointmentEndNotification;
